<template>
  <th data-int="cart-header-chapter">
    {{ $t('itemName', { item: $tc('chapter', 1)}) }}
  </th>
</template>

<script>
export default {
  name: 'CartHeaderUom'
};
</script>

<style scoped>

</style>
